<template>
  <v-app :theme="theme">
    <v-navigation-drawer v-model="drawer" :rail="rail" permanent>
      <v-list-item
        prepend-icon="mdi-domain"
        title="Eruhsat Yönetim"
        nav
      >
        <template v-slot:append>
          <v-btn
            :icon="rail ? 'mdi-chevron-right' : 'mdi-chevron-left'"
            variant="text"
            @click="rail = !rail"
          ></v-btn>
        </template>
      </v-list-item>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-item
          prepend-icon="mdi-map-marker-path"
          title="Parsel İşleri"
          value="tplotworks"
          :to="{ name: 'tplotworks' }"
          color="primary"
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-office-building"
          title="Yapı İşleri"
          value="tbuildingworks"
          :to="{ name: 'tbuildingworks' }"
          color="primary"
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-cog-outline"
          title="Tür Yönetimi"
          value="types"
          :to="{ name: 'types' }"
          color="primary"
        ></v-list-item>
        <v-list-item
          prepend-icon="mdi-database-cog-outline"
          title="Yönetim"
          value="admin"
          :to="{ name: 'admin' }"
          color="primary"
        ></v-list-item>
      </v-list>

      <template v-slot:append>
        <v-divider></v-divider>
        <v-list density="compact" nav>
          <v-list-item
            prepend-icon="mdi-brightness-6"
            :title="rail ? '' : (theme === 'dark' ? 'Açık Tema' : 'Koyu Tema')"
            @click="toggleTheme"
          ></v-list-item>
          <v-list-item
            prepend-icon="mdi-logout"
            title="Çıkış"
            @click="logout"
            color="error"
          ></v-list-item>
        </v-list>
        <v-list v-if="user && !rail" density="compact" nav class="pa-2">
          <v-list-item
            :subtitle="user.email || ''"
            :title="(user.singularFirstName || user.corporateName || 'Kullanıcı')"
            prepend-icon="mdi-account-circle"
          ></v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </v-main>
  </v-app>
</template>

<script>
import sharedVe from "../../shared-ve";
export default {
  data() {
    return {
      drawer: true,
      rail: true,
      theme: "light",
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  created() {
    const savedTheme = sessionStorage.getItem("theme");
    if (savedTheme) this.theme = savedTheme;

    this._redirectHandler = (path) => {
      this.$router.push(path);
    };
    this._redirectToHandler = () => {
      this.$router.push({ name: "login-form" });
    };

    sharedVe.on("redirect", this._redirectHandler);
    sharedVe.on("redirect-to", this._redirectToHandler);
  },
  beforeUnmount() {
    if (this._redirectHandler) sharedVe.off("redirect", this._redirectHandler);
    if (this._redirectToHandler) sharedVe.off("redirect-to", this._redirectToHandler);
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      sessionStorage.setItem("theme", this.theme);
      this.$vuetify.theme.global.name = this.theme;
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "login-form" });
    },
  },
};
</script>

